<template>
	<div class="changePassword">
		<div class="settingwarp">
			<header>
				<div style="display: block;">
					<div class="cu-custom" style="height: 45px;">
						<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
							<div class="content text-gold" style="top: 0px;">
								<div>{{$t('xiugaidenglu')}}</div>
							</div>
							<div class="action" @click="changego">
								<text class="cuIcon-back" style="width: 50px;">
									<span></span>
								</text>
							</div>
						</div>
					</div>
				</div>
				<!-- 		<div class="blockHeight"></div> -->
			</header>
			<div class="g-content">
				<div class="form">
					<van-field v-model="after_code" :placeholder="$t('pljiumima')">
						<template #label>
							<span class="addtitle">{{$t('jiumima')}}</span>
						</template>
					</van-field>
					<van-field v-model="new_code" :placeholder="$t('plxinmima')">
						<template #label>
							<span class="addtitle">{{$t('xinmima')}}</span>
						</template>
					</van-field>
					<van-field v-model="new_codeOk" :placeholder="$t('plquerenmima')">
						<template #label>
							<span class="addtitle">{{$t('querenmima')}}</span>
						</template>
					</van-field>
				</div>
				<div class="finish-btn">
					<van-button type="primary" round block class="Btnlogin"
						@click="changePWD">{{$t('tijiao')}}</van-button>
				</div>
			</div>
		</div>
		<alert-pop :alertType="3" :Tips="TipsTxt" v-if="PopAlert" @showAletfalse="showAletfalse"></alert-pop>
	</div>
</template>
<script>
	import AlertPop from "@/components/alert/AlertPop.vue";
	import userApi from "@/api/user";
	export default {
		name: "ChangePassword",
		components: {
			AlertPop
		},
		data() {
			return {
				new_code: "",
				new_codeOk: "",
				after_code: "",
				PopAlert: false,
				TipsTxt: this.$t('Tips.szcg'),
			};
		},
		methods: {
			showAletfalse() {
				this.PopAlert = false;
				this.$router.go(-1);
			},
			changego() {
				this.$router.go(-1);
			},
			changePWD() {
				if (!this.after_code) {
					this.$toast(this.$t('pljiumima'));
				} else if (!this.new_code) {
					this.$toast(this.$t('plxinmima'));
				} else if (!this.new_codeOk) {
					this.$toast(this.$t('plquerenmima'));
				} else if (this.new_code != this.new_codeOk) {
					this.$toast(this.$t('Tips.buyizhi'));
				} else {
					this.$toast.loading({
						message: this.$t('jiazaizhong'),
						forbidClick: true,
						duration: 300,
					});

					userApi
						.newPass(this.new_code, this.after_code)
						.then((data) => {
							console.log(data.data);
							this.$toast.success(this.$t('gunqq'));
							// this.PopAlert = true;
						})
						.catch((err) => {
							this.$toast.fail(err.msg);
						});
				}
			},
		},
		mounted() {},
	};
</script>
<style lang="less" scoped>
	/deep/.van-field__control {
		color: #181414;
	}

	/deep/.van-button--primary {
		color: var(--van-button-primary-color);
		background: #333;
		border: var(--van-button-border-width) solid #333;
	}

	/deep/.van-cell {
		position: relative;
		display: flex;
		box-sizing: border-box;
		width: 100%;
		padding: 10px 16px;
		overflow: hidden;
		color: #181414;
		font-size: 14px;
		line-height: 37px;
		background-color: unset;
		text-align: left;
	}

	.van-field__body {
		display: flex;
		align-items: center;
		padding-left: 10px;
	}

	/deep/.van-field__body {
		display: flex;
		align-items: center;
		padding-left: 10px;
	}

	/deep/.van-cell__value {
		border-color: rgb(229, 229, 229);
		background-color: rgb(255, 255, 255);
		display: flex;
		box-sizing: border-box;
		flex-direction: row;
		align-items: center;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
	}

	.g-content {
		padding: 15px;
	}

	.settingwarp {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.tips {
		padding: 0.1rem 0.2rem;
		margin-top: 0.4rem;
		font-size: 0.24rem;
		text-align: left;
	}

	.c_a0a0a0 {
		color: #a0a0a0;
	}

	.addtitle {
		// color: #fff;
	}

	.van-cell::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #3d5179;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}

	.finish-btn {
		margin-top: auto;
		margin-bottom: 0.4rem;
		padding: 0.2rem;
	}

	.Btnlogin {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		padding-left: 14px;
		padding-right: 14px;
		box-sizing: border-box;
		font-size: 18px;
		text-align: center;
		text-decoration: none;
		line-height: 2.55555556;
		border-radius: 5px;
		-webkit-tap-highlight-color: transparent;
		overflow: hidden;
		/* color: #000; */
		color: #b8a78a;
		/* background-color: #f8f8f8; */
		cursor: pointer;
		/* color: #fff; */
		/* background-color: #7d58c6; */
		/* border: 1px solid #7d58c6; */
	}
</style>